import TableView from './container';

export default TableView;
